










import { Component, Vue } from 'vue-property-decorator';
import { AllowSettings } from '@/types/converter/convert';
import { VueHelper } from '@/helpers/vue';
import DefaultPasswordRecoveryEmailComplete from '@/components/organisms/default/password_recovery/DefaultPasswordRecoveryEmailComplete.vue';
import PRS0000001PasswordRecoveryEmailComplete from '@/components/organisms/PRS0000001/password_recovery/PRS0000001PasswordRecoveryEmailComplete.vue';
import PRS0000001SubFooter from '@/components/organisms/PRS0000001/footer/PRS0000001SubFooter.vue';

@Component({
    components: {
        DefaultPasswordRecoveryEmailComplete,
        PRS0000001PasswordRecoveryEmailComplete,
        PRS0000001SubFooter
    }
})
export default class PasswordRecoveryEmailComplete extends Vue {

    private provisionShopCode: string = "";

    mounted () {
        this.provisionShopCode = VueHelper.getParameter(this, 'provision_shop_code')

        if (!AllowSettings.isUsePasswordRecovery(this.provisionShopCode)) {
            VueHelper.move(this, '/404')
        }
    }

}
